import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL || "https://bd.aimantra.info";
// const BASE_URL = process.env.REACT_APP_BASE_URL || "https://bkzrdhbv-8008.inc1.devtunnels.ms";

/* ─────────────────────────────────────────────
   Styles
───────────────────────────────────────────── */
const styles = `
.trs-wrapper {
  width: 100%;
  font-family: inherit;
}

/* ── Multi-select dropdown ── */
.trs-select-label {
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 6px;
  display: block;
  color: #333;
}
.trs-required { color: red; }

.trs-dropdown-container {
  position: relative;
  width: 100%;
  margin-bottom: 16px;
}

.trs-dropdown-toggle {
  width: 97%;
  min-height: 40px;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 7px 10px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  position: relative;
  box-sizing: border-box;
}
.trs-dropdown-toggle:focus-within {
  border-color: #2576bc;
  outline: none;
}
.trs-dropdown-arrow {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #666;
}
.trs-tag {
  background: #e8f0fb;
  color: #2576bc;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.trs-tag-remove {
  cursor: pointer;
  font-weight: bold;
  line-height: 1;
  background: none;
  border: none;
  color: #2576bc;
  padding: 0;
  font-size: 14px;
}
.trs-placeholder {
  color: #999;
  font-size: 14px;
}

.trs-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  z-index: 200;
  max-height: 260px;
  overflow-y: auto;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
}
.trs-search-input {
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  border: none;
  border-bottom: 1px solid #eee;
  outline: none;
  font-size: 13px;
}
.trs-menu-item {
  padding: 9px 12px;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #f5f5f5;
}
.trs-menu-item:last-child { border-bottom: none; }
.trs-menu-item:hover { background: #f0f6ff; }
.trs-menu-item.selected { background: #e8f0fb; }
.trs-menu-item.disabled-item {
  opacity: 0.45;
  cursor: not-allowed;
  background: #fafafa;
}
.trs-menu-item input[type="checkbox"] { accent-color: #2576bc; }

.trs-other-input-row {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px 12px;
  border-top: 1px solid #eee;
}
.trs-other-input {
  flex: 1;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  outline: none;
}
.trs-other-input:focus { border-color: #2576bc; }
.trs-other-add-btn {
  padding: 6px 14px;
  background: #2576bc;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}
.trs-other-add-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── Add button ── */
.trs-add-btn {
  padding: 8px 20px;
  background: #2576bc;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background 0.18s;
}
.trs-add-btn:hover { background: #1a5c96; }
.trs-add-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── Yes/No select ── */
.trs-yn-select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  background: #fff;
  outline: none;
  box-sizing: border-box;
}
.trs-yn-select:focus { border-color: #2576bc; }

.trs-field-block {
  margin-bottom: 16px;
}

/* ── Bidder table ── */
.trs-table-wrap {
  width: 100%;
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  margin-bottom: 8px;
}
.trs-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.trs-table th {
  background: #f0f6ff;
  padding: 9px 12px;
  text-align: center;
  font-weight: 600;
  color: #2576bc;
  border-bottom: 1px solid #d0dff0;
  white-space: nowrap;
}
.trs-table td {
  padding: 8px 10px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
}
.trs-table tr:last-child td { border-bottom: none; }
.trs-table tr:hover td { background: #fafcff; }

/* ── Winner row highlight ── */
.trs-table tr.winner-row td {
  background: #d4edda !important;
  border-bottom: 1px solid #b8dfc4;
}
.trs-table tr.winner-row:hover td {
  background: #c3e6cb !important;
}

/* ── Edit bidder row highlight ── */
.trs-table tr.editing-row td {
  background: #fffbf0 !important;
  border-bottom: 1px solid #ffe082;
}

.trs-score-input {
  width: 110px;
  padding: 5px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  text-align: center;
  outline: none;
  box-sizing: border-box;
}
.trs-score-input:focus { border-color: #2576bc; }

.trs-nr-select {
  width: 140px;
  padding: 5px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  background: #fff;
  outline: none;
  box-sizing: border-box;
}
.trs-nr-select:focus { border-color: #2576bc; }

.trs-save-btn {
  padding: 4px 12px;
  background: #2576bc;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
}
.trs-save-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.trs-save-btn.saved { background: #28a745; }

/* ── Edit button ── */
.trs-edit-btn {
  padding: 4px 10px;
  background: #f0f6ff;
  color: #2576bc;
  border: 1px solid #2576bc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  margin-left: 8px;
}
.trs-edit-btn:hover { background: #ddeeff; }

/* ── Edit bidder button (in table) ── */
.trs-edit-bidder-btn {
  padding: 4px 10px;
  background: #fff8e1;
  color: #f57c00;
  border: 1px solid #ffb74d;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.trs-edit-bidder-btn:hover { background: #ffe0b2; }

/* ── Cancel edit button ── */
.trs-cancel-edit-btn {
  padding: 4px 10px;
  background: #fafafa;
  color: #666;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  margin-left: 6px;
  white-space: nowrap;
}
.trs-cancel-edit-btn:hover { background: #f0f0f0; }

/* ── Save bidder btn ── */
.trs-save-bidder-btn {
  padding: 4px 12px;
  background: #28a745;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.trs-save-bidder-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── Read-only value display ── */
.trs-value-display {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.trs-amount-input {
  width: 130px;
  padding: 5px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  text-align: right;
  outline: none;
  box-sizing: border-box;
}
.trs-amount-input:focus { border-color: #2576bc; }

.trs-section-title {
  font-size: 15px;
  font-weight: 600;
  color: #2576bc;
  margin: 0 0 10px 0;
  padding-bottom: 6px;
  border-bottom: 2px solid #e8f0fb;
}
.trs-error { color: red; font-size: 12px; margin-top: 4px; }
.trs-loading { color: #888; font-size: 13px; padding: 8px 0; }

.trs-row-flex {
  display: flex;
  gap: 12px;
  align-items: center;
}

.trs-badge-nr {
  display: inline-block;
  background: #ffeaea;
  color: #c0392b;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
}
.trs-badge-l1 {
  display: inline-block;
  background: #e6f9ee;
  color: #27ae60;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
}

/* ── Rank badges ── */
.trs-badge-rank-h {
  display: inline-block;
  background: #fff3cd;
  color: #856404;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  border: 1px solid #ffc107;
}
.trs-badge-rank-h.h1 {
  background: #ffc107;
  color: #212529;
  border-color: #e0a800;
}
.trs-badge-rank-l {
  display: inline-block;
  background: #d1ecf1;
  color: #0c5460;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  border: 1px solid #bee5eb;
}
.trs-badge-rank-l.l1 {
  background: #17a2b8;
  color: #fff;
  border-color: #138496;
}

/* ── Winner radio ── */
.trs-winner-radio {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
}
.trs-winner-radio input[type="radio"] {
  accent-color: #28a745;
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.trs-winner-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #28a745;
  color: #fff;
  border-radius: 4px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 700;
}

/* ── Winner submit button ── */
.trs-winner-submit-btn {
  padding: 7px 20px;
  background: #28a745;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background 0.18s;
  margin-top: 10px;
}
.trs-winner-submit-btn:hover { background: #218838; }
.trs-winner-submit-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── Winner announced panel ── */
.trs-winner-panel {
  background: #f0fff4;
  border: 1px solid #b2dfdb;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 16px;
}
.trs-winner-panel-title {
  font-size: 13px;
  font-weight: 600;
  color: #1b5e20;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* ── Participating As ── */
.trs-participating-card {
  background: #f8fbff;
  border: 1px solid #d0e4f7;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}
.trs-participating-card-title {
  font-size: 13px;
  font-weight: 600;
  color: #2576bc;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}
/* ── Remove button on participating card ── */
.trs-participating-card-remove {
  margin-left: auto;
  background: none;
  border: 1px solid #e0b0b0;
  cursor: pointer;
  color: #c0392b;
  font-size: 16px;
  line-height: 1;
  padding: 2px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  transition: background 0.15s, border-color 0.15s;
}
.trs-participating-card-remove:hover {
  background: #ffeaea;
  border-color: #c0392b;
}
.trs-radio-group {
  display: flex;
  gap: 20px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}
.trs-radio-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #444;
  cursor: pointer;
}
.trs-radio-label input[type="radio"] {
  accent-color: #2576bc;
  width: 15px;
  height: 15px;
  cursor: pointer;
}
.trs-jv-fields {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.trs-jv-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.trs-jv-role-badge {
  min-width: 80px;
  text-align: center;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
}
.trs-jv-role-badge.lead {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffc107;
}
.trs-jv-role-badge.jv {
  background: #cce5ff;
  color: #004085;
  border: 1px solid #b8daff;
}
.trs-jv-role-badge.associate {
  background: #e2e3e5;
  color: #383d41;
  border: 1px solid #d6d8db;
}
.trs-jv-role-badge.partner {
  background: #e8d5f5;
  color: #6f42c1;
  border: 1px solid #c49beb;
}
.trs-jv-select {
  flex: 1;
  padding: 7px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 13px;
  background: #fff;
  outline: none;
  box-sizing: border-box;
}
.trs-jv-select:focus { border-color: #2576bc; }

/* ── JV partner chips in table ── */
.trs-jv-partner-list {
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-align: left;
}
.trs-jv-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
}
.trs-jv-chip-role {
  font-weight: 700;
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 3px;
}
.trs-jv-chip-role.lead { background: #fff3cd; color: #856404; border: 1px solid #ffc107; }
.trs-jv-chip-role.jv   { background: #cce5ff; color: #004085; border: 1px solid #b8daff; }
.trs-jv-chip-role.associate { background: #e2e3e5; color: #383d41; border: 1px solid #d6d8db; }
.trs-jv-chip-role.partner { background: #e8d5f5; color: #6f42c1; border: 1px solid #c49beb; }
.trs-sole-chip {
  font-size: 12px;
  color: #444;
  font-weight: 500;
}

/* ── Add partner row button ── */
.trs-add-partner-row-btn {
  padding: 5px 14px;
  background: #f0f6ff;
  color: #2576bc;
  border: 1px dashed #2576bc;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  margin-top: 6px;
  transition: background 0.15s;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.trs-add-partner-row-btn:hover { background: #ddeeff; }

.trs-remove-partner-row-btn {
  padding: 4px 8px;
  background: none;
  border: 1px solid #e0b0b0;
  border-radius: 4px;
  cursor: pointer;
  color: #c0392b;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
}
.trs-remove-partner-row-btn:hover { background: #ffeaea; }

/* ── Role select for dynamic JV rows ── */
.trs-role-select {
  min-width: 110px;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 12px;
  background: #fff;
  outline: none;
  font-weight: 600;
}
.trs-role-select:focus { border-color: #2576bc; }

/* ── Edit bidder modal / inline editor ── */
.trs-edit-bidder-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.35);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.trs-edit-bidder-modal {
  background: #fff;
  border-radius: 10px;
  padding: 24px;
      width: 70vw;
  height: 40vh;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 40px rgba(0,0,0,0.18);
}
.trs-edit-bidder-modal-title {
  font-size: 15px;
  font-weight: 700;
  color: #2576bc;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.trs-modal-actions {
  display: flex;
  gap: 10px;
  margin-top: 18px;
  justify-content: flex-end;
}
`;

/* ─────────────────────────────────────────────
   Helper: get all partner IDs currently used across ALL entries
───────────────────────────────────────────── */
function getAllUsedPartnerIds(entries) {
    const ids = new Set();
    for (const entry of entries) {
        if (entry.partner?.id) ids.add(entry.partner.id);
        for (const row of (entry.jvRows || [])) {
            if (row.partner?.id) ids.add(row.partner.id);
        }
    }
    return ids;
}

/* ─────────────────────────────────────────────
   Helper: get all partner IDs used inside a specific entry's JV rows
───────────────────────────────────────────── */
function getJvUsedIds(entry) {
    const ids = new Set();
    // if (entry.partner?.id) ids.add(entry.partner.id);
    for (const row of (entry.jvRows || [])) {
        if (row.partner?.id) ids.add(row.partner.id);
    }
    return ids;
}

/* ─────────────────────────────────────────────
   Helper: collect all partner names that are already in
   the saved bidders list — case-insensitive
───────────────────────────────────────────── */
function getExistingBidderSignatures(bidders) {
    const names = new Set();
    for (const b of bidders) {
        const name = (b.bidder_name || "").toLowerCase().trim();
        names.add(name);
        if (
            name.includes("lead:") ||
            name.includes("jv:") ||
            name.includes("associate:") ||
            name.includes("partner:")
        ) {
            const parts = name.split("|").map((s) => s.trim());
            for (const part of parts) {
                const colonIdx = part.indexOf(":");
                if (colonIdx !== -1) {
                    names.add(part.slice(colonIdx + 1).trim());
                }
            }
        }
    }
    return names;
}

/* ─────────────────────────────────────────────
   Ranking helpers
───────────────────────────────────────────── */
function buildTechRanks(bidders, rowState) {
    const scored = bidders
        .map((b) => {
            const live = rowState[b.id]?.tech_score ?? b.tech_score ?? "";
            const num = parseFloat(live);
            return {
                id: b.id,
                score: isNaN(num) || live === "Non Responsive" ? null : num,
            };
        })
        .filter((x) => x.score !== null);

    const sorted = [...scored].sort((a, b) => b.score - a.score);
    const rankMap = {};
    let rank = 1;
    for (let i = 0; i < sorted.length; i++) {
        if (i > 0 && sorted[i].score < sorted[i - 1].score) rank = i + 1;
        rankMap[sorted[i].id] = `H${rank}`;
    }
    return rankMap;
}

function buildFinancialRanks(bidders, rowState) {
    const amounts = bidders
        .map((b) => {
            const live = rowState[b.id]?.amount_bid ?? b.amount_bid ?? "";
            const isNR =
                rowState[b.id]?.tech_score === "Non Responsive" ||
                b.tech_score === "Non Responsive";
            const num = parseFloat(live);
            return { id: b.id, amount: isNaN(num) || isNR ? null : num };
        })
        .filter((x) => x.amount !== null);

    const sorted = [...amounts].sort((a, b) => a.amount - b.amount);
    const rankMap = {};
    let rank = 1;
    for (let i = 0; i < sorted.length; i++) {
        if (i > 0 && sorted[i].amount > sorted[i - 1].amount) rank = i + 1;
        rankMap[sorted[i].id] = `L${rank}`;
    }
    return rankMap;
}

/* ─────────────────────────────────────────────
   FIX #3: ALL-PARTNERS duplicate check helper
   Checks the combined list of partners + any already-selected partners
   for case-insensitive name collision.
───────────────────────────────────────────── */
function isPartnerNameDuplicate(name, partners, extraNames = []) {
    const trimmedLower = (name || "").toLowerCase().trim();
    if (!trimmedLower) return false;
    const inPartners = partners.some(
        (p) => (p.partner_name || "").toLowerCase().trim() === trimmedLower
    );
    const inExtra = extraNames.some(
        (n) => (n || "").toLowerCase().trim() === trimmedLower
    );
    return inPartners || inExtra;
}

/* ─────────────────────────────────────────────
   Single-select searchable dropdown (for JV roles)
───────────────────────────────────────────── */
function SingleSelectDropdown({
    partners,
    value,
    onChange,
    placeholder,
    excludeIds = [],
    loading,
    disabled,
    onPartnerCreated,
}) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [otherVal, setOtherVal] = useState("");
    const [otherError, setOtherError] = useState(""); // FIX #3
    const ref = useRef(null);

    useEffect(() => {
        function handleClick(e) {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    const filtered = partners.filter((p) =>
        (p.partner_name || "").toLowerCase().includes(search.toLowerCase())
    );

    const selectedPartner =
        partners.find((p) => p.id === value) ||
        (value && typeof value === "object" ? value : null);

    function select(p) {
        onChange(p);
        setSearch("");
        setOpen(false);
    }

    async function addOther() {
        if (!otherVal.trim()) return;
        setOtherError("");

        // FIX #3: case-insensitive duplicate check against ALL partners
        if (isPartnerNameDuplicate(otherVal, partners)) {
            setOtherError(
                `"${otherVal.trim()}" already exists. Select it from the list.`
            );
            return;
        }

        let newPartner;
        try {
            const res = await axios.post(`${BASE_URL}/siteproject/jvpartnerbd/`, {
                partner_name: otherVal.trim(),
            });
            newPartner = res.data;
        } catch {
            newPartner = {
                id: "other_" + Date.now(),
                partner_name: otherVal.trim(),
                isCustom: true,
            };
        }
        if (onPartnerCreated) onPartnerCreated(newPartner);
        onChange(newPartner);
        setOtherVal("");
        setOtherError("");
        setOpen(false);
    }

    if (disabled) {
        return (
            <div
                style={{
                    flex: 1,
                    padding: "7px 10px",
                    border: "1px solid #e0e0e0",
                    borderRadius: 5,
                    fontSize: 13,
                    background: "#f5f5f5",
                    color: "#555",
                    boxSizing: "border-box",
                }}
            >
                {selectedPartner ? (
                    selectedPartner.partner_name
                ) : (
                    <span style={{ color: "#aaa" }}>—</span>
                )}
            </div>
        );
    }

    return (
        <div
            className="trs-dropdown-container"
            ref={ref}
            style={{ marginBottom: 0, flex: 1 }}
        >
            <div
                className="trs-dropdown-toggle"
                style={{ minHeight: 36 }}
                onClick={() => { setOpen((v) => !v); setOtherError(""); }}
            >
                {selectedPartner ? (
                    <span style={{ fontSize: 13 }}>{selectedPartner.partner_name}</span>
                ) : (
                    <span className="trs-placeholder">{placeholder || "Select…"}</span>
                )}
                <span className="trs-dropdown-arrow">▾</span>
            </div>
            {otherError && (
                <div className="trs-error" style={{ marginTop: 4 }}>{otherError}</div>
            )}
            {open && (
                <div className="trs-dropdown-menu">
                    <input
                        className="trs-search-input"
                        placeholder="Search partners…"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                        autoFocus
                    />
                    {loading && (
                        <div className="trs-loading" style={{ padding: "10px 12px" }}>
                            Loading…
                        </div>
                    )}
                    {filtered.map((p) => {
                        const isExcluded = excludeIds.includes(p.id);
                        return (
                            <div
                                key={p.id}
                                className={`trs-menu-item${value === p.id ? " selected" : ""}${isExcluded ? " disabled-item" : ""
                                    }`}
                                onClick={() => {
                                    if (!isExcluded) select(p);
                                }}
                                title={isExcluded ? "Already used in this JV" : ""}
                            >
                                {p.partner_name}
                                {isExcluded && (
                                    <span
                                        style={{ marginLeft: "auto", fontSize: 10, color: "#c0392b" }}
                                    >
                                        In use
                                    </span>
                                )}
                            </div>
                        );
                    })}
                    {filtered.length === 0 && !loading && (
                        <div className="trs-menu-item" style={{ color: "#999" }}>
                            No partners found
                        </div>
                    )}
                    <div className="trs-other-input-row">
                        <input
                            className="trs-other-input"
                            placeholder="Add custom partner…"
                            value={otherVal}
                            onChange={(e) => { setOtherVal(e.target.value); setOtherError(""); }}
                            onKeyDown={(e) => e.key === "Enter" && addOther()}
                        />
                        <button
                            type="button"
                            className="trs-other-add-btn"
                            onClick={addOther}
                            disabled={!otherVal.trim()}
                        >
                            Add
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

/* ─────────────────────────────────────────────
   Multi-select dropdown with search + "Other"
───────────────────────────────────────────── */
function MultiSelectDropdown({
    partners,
    selected,
    onChange,
    loading,
    onPartnerCreated,
    disabledIds = [],
}) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [otherVal, setOtherVal] = useState("");
    const [duplicateError, setDuplicateError] = useState("");
    const ref = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        function handleClick(e) {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    const filtered = partners.filter((p) =>
        (p.partner_name || "").toLowerCase().includes(search.toLowerCase())
    );

    function toggle(partner) {
        if (disabledIds.includes(partner.id)) return;
        setDuplicateError("");
        const exists = selected.find((s) => s.id === partner.id);
        if (exists) {
            onChange(selected.filter((s) => s.id !== partner.id));
        } else {
            onChange([...selected, partner]);
            setOpen(false);
            setSearch("");
        }
    }

    function removeTag(id) {
        setDuplicateError("");
        onChange(selected.filter((s) => s.id !== id));
    }

    async function addOther() {
        if (isSubmitting || !otherVal.trim()) return;

        setIsSubmitting(true);
        setDuplicateError("");

        const selectedNames = selected.map((s) => s.partner_name);

        if (isPartnerNameDuplicate(otherVal, partners, selectedNames)) {
            setDuplicateError(
                `"${otherVal.trim()}" already exists. Please select it from the list.`
            );
            setIsSubmitting(false);
            return;
        }

        try {
            const res = await axios.post(`${BASE_URL}/siteproject/jvpartnerbd/`, {
                partner_name: otherVal.trim(),
            });

            const newPartner = res.data;

            if (onPartnerCreated) onPartnerCreated(newPartner);
            onChange([...selected, newPartner]);

            setOtherVal("");
            setOpen(false);
            setIsSubmitting(false); // ← ADD THIS LINE (was missing — caused permanent disable)

        } catch (err) {
            setIsSubmitting(false); // allow retry if API failed
        }
    }
    return (
        <div className="trs-dropdown-container" ref={ref}>
            <div
                className="trs-dropdown-toggle"
                onClick={() => {
                    setOpen((v) => !v);
                    setDuplicateError("");
                }}
            >
                {selected.length === 0 && (
                    <span className="trs-placeholder">Select bidders…</span>
                )}
                {selected.map((s) => (
                    <span key={s.id} className="trs-tag">
                        {s.partner_name}
                        <button
                            className="trs-tag-remove"
                            onClick={(e) => {
                                e.stopPropagation();
                                removeTag(s.id);
                            }}
                        >
                            ×
                        </button>
                    </span>
                ))}
                <span className="trs-dropdown-arrow">▾</span>
            </div>
            {duplicateError && (
                <div className="trs-error" style={{ marginTop: 4 }}>
                    {duplicateError}
                </div>
            )}
            {open && (
                <div className="trs-dropdown-menu">
                    <input
                        className="trs-search-input"
                        placeholder="Search partners…"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                        autoFocus
                    />
                    {loading && (
                        <div className="trs-loading" style={{ padding: "10px 12px" }}>
                            Loading…
                        </div>
                    )}
                    {filtered.map((p) => {
                        const isSelected = !!selected.find((s) => s.id === p.id);
                        const isDisabled = disabledIds.includes(p.id) && !isSelected;
                        return (
                            <div
                                key={p.id}
                                className={`trs-menu-item${isSelected ? " selected" : ""}${isDisabled ? " disabled-item" : ""
                                    }`}
                                onClick={() => toggle(p)}
                                title={
                                    isDisabled
                                        ? "Already used as a JV partner in another bidder"
                                        : ""
                                }
                            >
                                <input type="checkbox" readOnly checked={isSelected} />
                                {p.partner_name}
                                {isDisabled && (
                                    <span
                                        style={{ marginLeft: "auto", fontSize: 10, color: "#c0392b" }}
                                    >
                                        In JV
                                    </span>
                                )}
                            </div>
                        );
                    })}
                    {filtered.length === 0 && !loading && (
                        <div className="trs-menu-item" style={{ color: "#999" }}>
                            No partners found
                        </div>
                    )}
                    <div className="trs-other-input-row">
                        <input
                            className="trs-other-input"
                            placeholder="Add custom bidder name…"
                            value={otherVal}
                            onChange={(e) => {
                                setOtherVal(e.target.value);
                                setDuplicateError("");
                            }}
                            onKeyDown={(e) => e.key === "Enter" && addOther()}
                        />
                        <button
                            type="button"
                            className="trs-other-add-btn"
                            onClick={addOther}
                            disabled={!otherVal.trim() || isSubmitting}
                        >
                            {isSubmitting ? "Adding…" : "Add"}  {/* ← changed "Added ✓" to "Adding…" */}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

/* ─────────────────────────────────────────────
   JV_ROLES list — fixed first 3 + dynamic "Partner N"
───────────────────────────────────────────── */
const FIXED_ROLES = ["Lead", "JV", "Associate"];

function getRoleBadgeClass(role) {
    const r = (role || "").toLowerCase();
    if (r === "lead") return "lead";
    if (r === "jv") return "jv";
    if (r === "associate") return "associate";
    return "partner";
}

/* ─────────────────────────────────────────────
   FIX #2: isJvComplete — JV row is now OPTIONAL.
   Only requires at least 2 rows with a partner assigned,
   and at least "Lead" must be filled if it exists.
   This allows Lead + Associate (without JV) to be valid.
───────────────────────────────────────────── */
function isJvComplete(entry) {
    if (entry.participatingAs === "sole") return true;
    const rows = entry.jvRows || [];

    // Count rows that have a partner assigned
    const filledRows = rows.filter((r) => r.partner != null);
    if (filledRows.length < 2) return false;

    // Lead must be filled if the Lead row exists
    const leadRow = rows.find((r) => r.role === "Lead");
    if (leadRow && !leadRow.partner) return false;

    // All custom (non-FIXED) rows must have a partner if they were added
    for (const row of rows) {
        if (row.isCustomRole && !row.partner) return false;
    }

    return true;
}

/* ─────────────────────────────────────────────
   Participating As Builder (dynamic JV rows)
───────────────────────────────────────────── */
function ParticipatingAsBuilder({
    partners,
    partnersLoading,
    entries,
    onChange,
    onRemove,
    onPartnerCreated,
}) {
    function updateEntry(idx, patch) {
        const next = entries.map((e, i) => (i === idx ? { ...e, ...patch } : e));
        onChange(next);
    }

    function updateJvRow(entryIdx, rowIdx, patch) {
        const entry = entries[entryIdx];
        const newRows = entry.jvRows.map((r, i) =>
            i === rowIdx ? { ...r, ...patch } : r
        );
        updateEntry(entryIdx, { jvRows: newRows });
    }

    function addJvRow(entryIdx) {
        const entry = entries[entryIdx];
        const existingCustom = (entry.jvRows || []).filter(
            (r) => !FIXED_ROLES.includes(r.role)
        );
        const newRole = `Partner ${existingCustom.length + 1}`;
        updateEntry(entryIdx, {
            jvRows: [
                ...(entry.jvRows || []),
                { role: newRole, partner: null, isCustomRole: true },
            ],
        });
    }

    function removeJvRow(entryIdx, rowIdx) {
        const entry = entries[entryIdx];
        const newRows = entry.jvRows.filter((_, i) => i !== rowIdx);
        updateEntry(entryIdx, { jvRows: newRows });
    }

    if (entries.length === 0) return null;

    return (
        <div className="trs-field-block">
            {entries.map((entry, idx) => {
                const usedIdsInThisEntry = getJvUsedIds(entry);

                return (
                    <div
                        key={entry.partner?.id ?? idx}
                        className="trs-participating-card"
                    >
                        <div className="trs-participating-card-title">
                            🏢 {entry.partner?.partner_name || `Bidder ${idx + 1}`} —
                            Participating As
                            <button
                                type="button"
                                className="trs-participating-card-remove"
                                title="Remove this bidder"
                                onClick={() => onRemove && onRemove(entry.partner?.id)}
                            >
                                × Remove
                            </button>
                        </div>

                        {/* Sole / JV radio */}
                        <div className="trs-radio-group">
                            <label className="trs-radio-label">
                                <input
                                    type="radio"
                                    name={`participating_${idx}`}
                                    value="sole"
                                    checked={entry.participatingAs === "sole"}
                                    onChange={() =>
                                        updateEntry(idx, {
                                            participatingAs: "sole",
                                            jvRows: [
                                                { role: "Lead", partner: null },
                                                { role: "JV", partner: null },
                                                { role: "Associate", partner: null },
                                            ],
                                        })
                                    }
                                />
                                Sole
                            </label>
                            <label className="trs-radio-label">
                                <input
                                    type="radio"
                                    name={`participating_${idx}`}
                                    value="jv"
                                    checked={entry.participatingAs === "jv"}
                                    onChange={() => {
                                        const rows = [
                                            ...(entry.jvRows || [
                                                { role: "Lead", partner: null },
                                                { role: "JV", partner: null },
                                                { role: "Associate", partner: null },
                                            ]),
                                        ];
                                        const alreadyAssigned = rows.some(
                                            (r) => r.partner?.id === entry.partner?.id
                                        );
                                        if (!alreadyAssigned) {
                                            const firstEmpty = rows.findIndex((r) => !r.partner);
                                            if (firstEmpty !== -1) {
                                                rows[firstEmpty] = {
                                                    ...rows[firstEmpty],
                                                    partner: entry.partner,
                                                };
                                            }
                                        }
                                        updateEntry(idx, { participatingAs: "jv", jvRows: rows });
                                    }}
                                />
                                JV (Joint Venture)
                            </label>
                        </div>

                        {/* JV sub-form */}
                        {entry.participatingAs === "jv" && (
                            <div className="trs-jv-fields">
                                {(entry.jvRows || []).map((row, rowIdx) => {
                                    const excludeForThisRow = [...usedIdsInThisEntry].filter(
                                        (id) => id !== row.partner?.id
                                    );
                                    const isMainPartner =
                                        row.partner?.id === entry.partner?.id;

                                    return (
                                        <div key={rowIdx} className="trs-jv-row">
                                            {/* Role label or input for custom rows */}
                                            {FIXED_ROLES.includes(row.role) ? (
                                                <span
                                                    className={`trs-jv-role-badge ${getRoleBadgeClass(
                                                        row.role
                                                    )}`}
                                                >
                                                    {row.role}
                                                </span>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="trs-role-select"
                                                    value={row.role}
                                                    onChange={(e) =>
                                                        updateJvRow(idx, rowIdx, { role: e.target.value })
                                                    }
                                                    placeholder="Role name"
                                                    style={{
                                                        minWidth: 90,
                                                        padding: "5px 8px",
                                                        border: "1px solid #c49beb",
                                                        borderRadius: 5,
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        background: "#f9f2ff",
                                                        color: "#6f42c1",
                                                    }}
                                                />
                                            )}

                                            <SingleSelectDropdown
                                                partners={partners}
                                                value={row.partner?.id ?? null}
                                                onChange={(p) =>
                                                    updateJvRow(idx, rowIdx, { partner: p })
                                                }
                                                placeholder={`Select ${row.role} partner…`}
                                                excludeIds={excludeForThisRow}
                                                loading={partnersLoading}
                                                disabled={isMainPartner}
                                                onPartnerCreated={onPartnerCreated}
                                            />

                                            {/* FIX #2: allow removing any FIXED row that is not the main partner,
                                                so user can remove JV row and keep Lead + Associate */}
                                            {!isMainPartner && (
                                                <button
                                                    type="button"
                                                    className="trs-remove-partner-row-btn"
                                                    onClick={() => removeJvRow(idx, rowIdx)}
                                                    title={`Remove ${row.role} row`}
                                                >
                                                    ×
                                                </button>
                                            )}
                                        </div>
                                    );
                                })}

                                <button
                                    type="button"
                                    className="trs-add-partner-row-btn"
                                    onClick={() => addJvRow(idx)}
                                >
                                    + Add Partner
                                </button>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}

/* ─────────────────────────────────────────────
   Helper: build bidder_name from entry
───────────────────────────────────────────── */
function buildBidderName(entry) {
    if (entry.participatingAs === "sole") {
        return entry.partner.partner_name;
    }
    const parts = [];
    for (const row of entry.jvRows || []) {
        if (row.partner) {
            parts.push(`${row.role}: ${row.partner.partner_name}`);
        }
    }
    return parts.join(" | ");
}

/* ─────────────────────────────────────────────
   Helper: parse a saved bidder_name back into entry shape
   so the edit modal can pre-populate correctly
───────────────────────────────────────────── */
function parseBidderNameToEntry(bidder, partners) {
    const name = bidder.bidder_name || "";
    const isJv = name.includes(":") && name.includes("|");

    if (!isJv) {
        // Sole — try to find the partner object by name
        const partnerObj = partners.find(
            (p) => (p.partner_name || "").toLowerCase() === name.toLowerCase()
        ) || { id: "parsed_" + bidder.id, partner_name: name };

        return {
            partner: partnerObj,
            participatingAs: "sole",
            jvRows: [
                { role: "Lead", partner: null },
                { role: "JV", partner: null },
                { role: "Associate", partner: null },
            ],
        };
    }

    // JV — parse "Role: Name | Role: Name | ..."
    const rawParts = name.split("|").map((s) => s.trim());
    const jvRows = rawParts.map((part) => {
        const colonIdx = part.indexOf(":");
        const role = colonIdx !== -1 ? part.slice(0, colonIdx).trim() : "Partner";
        const partnerName = colonIdx !== -1 ? part.slice(colonIdx + 1).trim() : part;
        const partnerObj = partners.find(
            (p) => (p.partner_name || "").toLowerCase() === partnerName.toLowerCase()
        ) || { id: "parsed_" + partnerName, partner_name: partnerName };
        const isCustomRole = !FIXED_ROLES.includes(role);
        return { role, partner: partnerObj, isCustomRole };
    });

    // Fill missing fixed roles so the UI shows all three rows
    for (const fixedRole of FIXED_ROLES) {
        if (!jvRows.find((r) => r.role === fixedRole)) {
            jvRows.push({ role: fixedRole, partner: null });
        }
    }

    // The "main" partner is the first filled row's partner
    const mainPartner = jvRows[0]?.partner || {
        id: "parsed_" + bidder.id,
        partner_name: name,
    };

    return {
        partner: mainPartner,
        participatingAs: "jv",
        jvRows,
    };
}

/* ─────────────────────────────────────────────
   JV Partner display cell (in table)
───────────────────────────────────────────── */
function BidderNameCell({ bidder }) {
    const name = bidder.bidder_name || "";

    if (name.includes(":") && name.includes("|")) {
        const parts = name.split("|").map((s) => s.trim());
        return (
            <div className="trs-jv-partner-list">
                {parts.map((part, i) => {
                    const colonIdx = part.indexOf(":");
                    if (colonIdx === -1)
                        return (
                            <span key={i} className="trs-sole-chip">
                                {part}
                            </span>
                        );
                    const role = part.slice(0, colonIdx).trim();
                    const partnerName = part.slice(colonIdx + 1).trim();
                    const roleKey = role.toLowerCase();
                    return (
                        <span key={i} className="trs-jv-chip">
                            <span className={`trs-jv-chip-role ${getRoleBadgeClass(roleKey)}`}>
                                {role}
                            </span>
                            <span>{partnerName}</span>
                        </span>
                    );
                })}
            </div>
        );
    }

    return <span className="trs-sole-chip">{name}</span>;
}

/* ─────────────────────────────────────────────
   Edit Bidder Modal
   Allows editing an existing bidder's name / JV partners.
───────────────────────────────────────────── */
function EditBidderModal({
    bidder,
    partners,
    partnersLoading,
    onPartnerCreated,
    onSave,
    onClose,
    allBidders,
}) {
    const [entry, setEntry] = useState(() =>
        parseBidderNameToEntry(bidder, partners)
    );
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    // Prevent background scroll while modal is open
    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => { document.body.style.overflow = ""; };
    }, []);

    function getJvUsedIdsLocal(e) {
        const ids = new Set();
        // if (e.partner?.id) ids.add(e.partner.id);
        for (const row of (e.jvRows || [])) {
            if (row.partner?.id) ids.add(row.partner.id);
        }
        return ids;
    }

    function updateJvRow(rowIdx, patch) {
        setEntry((prev) => ({
            ...prev,
            jvRows: prev.jvRows.map((r, i) =>
                i === rowIdx ? { ...r, ...patch } : r
            ),
        }));
    }

    function addJvRow() {
        setEntry((prev) => {
            const existingCustom = (prev.jvRows || []).filter(
                (r) => !FIXED_ROLES.includes(r.role)
            );
            const newRole = `Partner ${existingCustom.length + 1}`;
            return {
                ...prev,
                jvRows: [
                    ...(prev.jvRows || []),
                    { role: newRole, partner: null, isCustomRole: true },
                ],
            };
        });
    }

    function removeJvRow(rowIdx) {
        setEntry((prev) => ({
            ...prev,
            jvRows: prev.jvRows.filter((_, i) => i !== rowIdx),
        }));
    }

    async function handleSave(e) {
        e.preventDefault();
        e.stopPropagation();
        setError("");

        if (!isJvComplete(entry)) {
            setError(
                "Please assign at least 2 partners (including Lead) for JV entries."
            );
            return;
        }

        const newBidderName = buildBidderName(entry);

        // Check for name conflict with other bidders (excluding self)
        const conflict = allBidders.find(
            (b) =>
                b.id !== bidder.id &&
                (b.bidder_name || "").toLowerCase().trim() ===
                newBidderName.toLowerCase().trim()
        );
        if (conflict) {
            setError(`A bidder with this name already exists: "${conflict.bidder_name}"`);
            return;
        }

        setSaving(true);
        try {
            const jvPayload = {};
            if (entry.participatingAs === "jv") {
                const rows = entry.jvRows || [];
                const lead = rows.find((r) => r.role === "Lead");
                const jv = rows.find((r) => r.role === "JV");
                const associate = rows.find((r) => r.role === "Associate");
                if (lead?.partner) jvPayload.lead_partner = lead.partner.partner_name;
                if (jv?.partner) jvPayload.jv_partner = jv.partner.partner_name;
                if (associate?.partner)
                    jvPayload.associate_partner = associate.partner.partner_name;
                const extras = rows.filter(
                    (r) => !FIXED_ROLES.includes(r.role) && r.partner
                );
                if (extras.length > 0) {
                    jvPayload.extra_partners = extras.map((r) => ({
                        role: r.role,
                        partner: r.partner.partner_name,
                    }));
                }
            }

            await axios.put(`${BASE_URL}/siteproject/bidder/${bidder.id}/`, {
                bidder_name: newBidderName,
                participating_as: entry.participatingAs,
                ...(entry.participatingAs === "jv" && jvPayload),
            });

            onSave();
        } catch (err) {
            console.error("Error updating bidder:", err);
            setError("Failed to update bidder. Please try again.");
        } finally {
            setSaving(false);
        }
    }

    const usedIdsInEntry = getJvUsedIdsLocal(entry);

    return (
        <div className="trs-edit-bidder-overlay" onClick={onClose}>
            <div
                className="trs-edit-bidder-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="trs-edit-bidder-modal-title">
                    ✏️ Edit Bidder — {bidder.bidder_name}
                </div>

                {/* Sole / JV toggle */}
                <div className="trs-radio-group" style={{ marginBottom: 14 }}>
                    <label className="trs-radio-label">
                        <input
                            type="radio"
                            name="edit_participating"
                            value="sole"
                            checked={entry.participatingAs === "sole"}
                            onChange={() =>
                                setEntry((prev) => ({
                                    ...prev,
                                    participatingAs: "sole",
                                    jvRows: [
                                        { role: "Lead", partner: null },
                                        { role: "JV", partner: null },
                                        { role: "Associate", partner: null },
                                    ],
                                }))
                            }
                        />
                        Sole
                    </label>
                    <label className="trs-radio-label">
                        <input
                            type="radio"
                            name="edit_participating"
                            value="jv"
                            checked={entry.participatingAs === "jv"}
                            onChange={() =>
                                setEntry((prev) => {
                                    const rows = [
                                        ...(prev.jvRows?.length
                                            ? prev.jvRows
                                            : [
                                                { role: "Lead", partner: null },
                                                { role: "JV", partner: null },
                                                { role: "Associate", partner: null },
                                            ]),
                                    ];

                                    // Auto-place the original (sole) partner into the first empty row
                                    const alreadyAssigned = rows.some(
                                        (r) => r.partner?.id === prev.partner?.id
                                    );

                                    if (!alreadyAssigned && prev.partner) {
                                        const firstEmpty = rows.findIndex((r) => !r.partner);

                                        if (firstEmpty !== -1) {
                                            rows[firstEmpty] = {
                                                ...rows[firstEmpty],
                                                partner: prev.partner,
                                            };
                                        }
                                    }

                                    return {
                                        ...prev,
                                        participatingAs: "jv",
                                        jvRows: rows,
                                    };
                                })
                            }
                        />
                        JV (Joint Venture)
                    </label>
                </div>

                {/* Sole: show partner name field */}
                {entry.participatingAs === "sole" && (
                    <div style={{ marginBottom: 14 }}>
                        <label className="trs-select-label">Bidder Name</label>
                        <SingleSelectDropdown
                            partners={partners}
                            value={entry.partner?.id ?? null}
                            onChange={(p) =>
                                setEntry((prev) => ({ ...prev, partner: p }))
                            }
                            placeholder="Select partner…"
                            loading={partnersLoading}
                            onPartnerCreated={onPartnerCreated}
                        />
                    </div>
                )}

                {/* JV rows */}
                {entry.participatingAs === "jv" && (
                    <div className="trs-jv-fields">
                        {(entry.jvRows || []).map((row, rowIdx) => {
                            const excludeForThisRow = [...usedIdsInEntry].filter(
                                (id) => id !== row.partner?.id
                            );

                            return (
                                <div key={rowIdx} className="trs-jv-row">
                                    {FIXED_ROLES.includes(row.role) ? (
                                        <span
                                            className={`trs-jv-role-badge ${getRoleBadgeClass(row.role)}`}
                                        >
                                            {row.role}
                                        </span>
                                    ) : (
                                        <input
                                            type="text"
                                            className="trs-role-select"
                                            value={row.role}
                                            onChange={(e) =>
                                                updateJvRow(rowIdx, { role: e.target.value })
                                            }
                                            placeholder="Role name"
                                            style={{
                                                minWidth: 90,
                                                padding: "5px 8px",
                                                border: "1px solid #c49beb",
                                                borderRadius: 5,
                                                fontSize: 12,
                                                fontWeight: 600,
                                                background: "#f9f2ff",
                                                color: "#6f42c1",
                                            }}
                                        />
                                    )}

                                    <SingleSelectDropdown
                                        partners={partners}
                                        value={row.partner?.id ?? null}
                                        onChange={(p) => updateJvRow(rowIdx, { partner: p })}
                                        placeholder={`Select ${row.role} partner…`}
                                        excludeIds={excludeForThisRow}
                                        loading={partnersLoading}
                                        onPartnerCreated={onPartnerCreated}
                                    />

                                    <button
                                        type="button"
                                        className="trs-remove-partner-row-btn"
                                        onClick={() => removeJvRow(rowIdx)}
                                        title={`Remove ${row.role} row`}
                                    >
                                        ×
                                    </button>
                                </div>
                            );
                        })}

                        <button
                            type="button"
                            className="trs-add-partner-row-btn"
                            onClick={addJvRow}
                        >
                            + Add Partner
                        </button>
                    </div>
                )}

                {error && (
                    <div className="trs-error" style={{ marginTop: 10 }}>{error}</div>
                )}

                <div className="trs-modal-actions">
                    <button
                        type="button"
                        className="trs-cancel-edit-btn"
                        onClick={onClose}
                        disabled={saving}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="trs-save-bidder-btn"
                        onClick={handleSave}
                        disabled={saving || !isJvComplete(entry)}
                    >
                        {saving ? "Saving…" : "Save Changes"}
                    </button>
                </div>
            </div>
        </div>
    );
}

/* ─────────────────────────────────────────────
   Main Component
───────────────────────────────────────────── */
export default function TenderResultSection({
    tenderId,
    tenderIdCode,
    wishListData,
    setWishListData,
    roleemp,
}) {
    const [partners, setPartners] = useState([]);
    const [partnersLoading, setPartnersLoading] = useState(false);
    const [isAddingBidders, setIsAddingBidders] = useState(false);

    const [selectedPartners, setSelectedPartners] = useState([]);
    const [participatingEntries, setParticipatingEntries] = useState([]);

    const [bidders, setBidders] = useState([]);
    const [biddersLoading, setBiddersLoading] = useState(false);
    const [rowState, setRowState] = useState({});
    const [addError, setAddError] = useState("");
    const [bgData, setBgData] = useState([]);

    // NEW: edit bidder modal state
    const [editingBidder, setEditingBidder] = useState(null);
    const [tenderRecord, setTenderRecord] = useState(null);

    useEffect(() => {
        if (!tenderId) return;
        axios
            .get(`${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`)
            .then((res) => {
                console.log("Tender record fetched by UUID:", res.data); // ← check this in console
                setTenderRecord(res.data);
            })
            .catch((err) => {
                console.error("Error fetching tender record:", err);
            });
    }, [tenderId]);

    const [isWinnerAnnounced, setIsWinnerAnnounced] = useState(
        wishListData?.is_winner_announced ?? false
    );
    const [selectedWinnerId, setSelectedWinnerId] = useState(null);
    const [winnerSubmitting, setWinnerSubmitting] = useState(false);
    const [winnerSubmitError, setWinnerSubmitError] = useState("");

    const hasAnyTechScore = bidders.some(
        (b) =>
            b.tech_score !== null &&
            b.tech_score !== undefined &&
            b.tech_score !== ""
    );
    const hasAnyAmount = bidders.some(
        (b) =>
            b.amount_bid !== null &&
            b.amount_bid !== undefined &&
            b.amount_bid !== ""
    );

    const isTechOpen = wishListData?.tech_open === true;
    const isFinancialOpen = wishListData?.financial_status === true;

    const isCvRole =
        roleemp === "CertificationAccessCvTeamHead" ||
        roleemp === "CertificationAccessCvTeam";

    const techRankMap = buildTechRanks(bidders, rowState);
    const financialRankMap = buildFinancialRanks(bidders, rowState);

    const showTechColumn = isTechOpen || hasAnyTechScore;
    const showFinancialColumn = isFinancialOpen || hasAnyAmount;
    const showColumns = showTechColumn || showFinancialColumn;
    const showTechRankColumn =
        showTechColumn && Object.keys(techRankMap).length > 0;
    const showFinancialRankColumn =
        showFinancialColumn && Object.keys(financialRankMap).length > 0;

    const savedWinnerId =
        bidders.find((b) => b.winning_bidder === true)?.id ?? null;

    /* ── IDs used as JV sub-partners (greyed out in top multi-select) ── */
    const allJvSubPartnerIds = React.useMemo(() => {
        const ids = new Set();
        for (const entry of participatingEntries) {
            for (const row of entry.jvRows || []) {
                if (row.partner?.id && row.partner.id !== entry.partner?.id) {
                    ids.add(row.partner.id);
                }
            }
        }
        return [...ids];
    }, [participatingEntries]);

    /* ── Sync participating entries when selectedPartners changes ── */
    useEffect(() => {
        setParticipatingEntries((prev) => {
            const next = selectedPartners.map((partner) => {
                const existing = prev.find((e) => e.partner?.id === partner.id);
                return (
                    existing || {
                        partner,
                        participatingAs: "sole",
                        jvRows: [
                            { role: "Lead", partner: null },
                            { role: "JV", partner: null },
                            { role: "Associate", partner: null },
                        ],
                    }
                );
            });
            return next;
        });
    }, [selectedPartners]);

    useEffect(() => {
        if (hasAnyTechScore && wishListData?.tech_open !== true) {
            setWishListData((prev) => ({ ...prev, tech_open: true }));
        }
        if (hasAnyAmount && wishListData?.financial_status !== true) {
            setWishListData((prev) => ({ ...prev, financial_status: true }));
        }
    }, [hasAnyTechScore, hasAnyAmount]);

    useEffect(() => {
        setIsWinnerAnnounced(wishListData?.is_winner_announced ?? false);
    }, [wishListData?.is_winner_announced]);

    useEffect(() => {
        if (isWinnerAnnounced && savedWinnerId && !selectedWinnerId) {
            setSelectedWinnerId(savedWinnerId);
        }
    }, [isWinnerAnnounced, savedWinnerId]);

    /* ── Fetch partners ── */
    useEffect(() => {
        setPartnersLoading(true);
        axios
            .get(`${BASE_URL}/siteproject/jvpartnerbd/`)
            .then((res) =>
                setPartners(Array.isArray(res.data) ? res.data : [])
            )
            .catch(() => setPartners([]))
            .finally(() => setPartnersLoading(false));
    }, []);

    /* ── Fetch bidders ── */
    const fetchBidders = () => {
        if (!tenderId) return;
        setBiddersLoading(true);
        axios
            .get(`${BASE_URL}/siteproject/bidderfilter/${tenderId}/`)
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                setBidders(data);
                setRowState((prev) => {
                    const next = { ...prev };
                    data.forEach((b) => {
                        const existing = prev[b.id];
                        const hasTechValue =
                            b.tech_score !== null &&
                            b.tech_score !== undefined &&
                            b.tech_score !== "";
                        const hasAmountValue =
                            b.amount_bid !== null &&
                            b.amount_bid !== undefined &&
                            b.amount_bid !== "";
                        const techEditing =
                            existing?.techEditing === true ? true : !hasTechValue;
                        const amountEditing =
                            existing?.amountEditing === true ? true : !hasAmountValue;
                        next[b.id] = {
                            tech_score:
                                existing?.techEditing === true
                                    ? existing.tech_score
                                    : b.tech_score ?? "",
                            amount_bid:
                                existing?.amountEditing === true
                                    ? existing.amount_bid
                                    : b.amount_bid ?? "",
                            techEditing,
                            amountEditing,
                            saving: existing?.saving ?? false,
                            saved: existing?.saved ?? false,
                            error: existing?.error ?? "",
                        };
                    });
                    return next;
                });
            })
            .catch(() => setBidders([]))
            .finally(() => setBiddersLoading(false));
    };

    useEffect(() => {
        fetchBidders();
    }, [tenderId]);


    const getBgDetails = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/bgdetailsforbdpost/`);
            setBgData(Array.isArray(response.data) ? response.data : []);
        } catch (err) {
            console.error("Error fetching bg details:", err);
        }
    };

    useEffect(() => {
        getBgDetails();
    }, []);



    /* ── Central handler to add a newly created partner to global list ── */
    function handlePartnerCreated(newPartner) {
        setPartners((prev) => {
            if (prev.some((p) => p.id === newPartner.id)) return prev;
            return [...prev, newPartner];
        });
    }

    /* ── Remove a single bidder from the selection & cards ── */
    function handleRemoveEntry(partnerId) {
        setSelectedPartners((prev) => prev.filter((p) => p.id !== partnerId));
    }

    /* ─────────────────────────────────────────────
       Add bidders
    ───────────────────────────────────────────── */
    async function handleAddBidders(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!participatingEntries.length) return;
        if (isAddingBidders) return;

        setIsAddingBidders(true);
        setAddError("");

        // FIX: was missing `return` after setAddError, so it fell through
        const incomplete = participatingEntries.find((en) => !isJvComplete(en));
        if (incomplete) {
            setAddError(
                "Please assign at least 2 partners (including Lead) for all JV entries."
            );
            setIsAddingBidders(false); // FIX: must reset here too
            return;
        }

        const existingSigs = getExistingBidderSignatures(bidders);

        const duplicates = [];
        for (const entry of participatingEntries) {
            const bidderName = buildBidderName(entry);
            const nameLower = bidderName.toLowerCase().trim();

            if (existingSigs.has(nameLower)) {
                duplicates.push(entry.partner.partner_name);
                continue;
            }

            if (entry.participatingAs === "sole") {
                const partnerNameLower = (
                    entry.partner.partner_name || ""
                ).toLowerCase().trim();
                if (existingSigs.has(partnerNameLower)) {
                    duplicates.push(entry.partner.partner_name);
                    continue;
                }
            }

            if (entry.participatingAs === "jv") {
                for (const row of entry.jvRows || []) {
                    if (row.partner) {
                        const subNameLower = (
                            row.partner.partner_name || ""
                        ).toLowerCase().trim();
                        if (existingSigs.has(subNameLower)) {
                            duplicates.push(
                                `${row.partner.partner_name} (as ${row.role} in ${entry.partner.partner_name})`
                            );
                        }
                    }
                }
            }
        }

        if (duplicates.length > 0) {
            setAddError(
                `The following bidder(s) are already in the list: ${duplicates.join(
                    ", "
                )}. Please remove duplicates.`
            );
            setIsAddingBidders(false); // FIX: must reset here too
            return;
        }

        const newNames = new Set();
        const inBatchDuplicates = [];
        for (const entry of participatingEntries) {
            const bidderName = buildBidderName(entry).toLowerCase().trim();
            if (newNames.has(bidderName)) {
                inBatchDuplicates.push(entry.partner.partner_name);
            }
            newNames.add(bidderName);
        }
        if (inBatchDuplicates.length > 0) {
            setAddError(
                `Duplicate entries in selection: ${inBatchDuplicates.join(", ")}.`
            );
            setIsAddingBidders(false); // FIX: must reset here too
            return;
        }

        try {
            await Promise.all(
                participatingEntries.map((entry) => {
                    const bidderName = buildBidderName(entry);
                    const jvPayload = {};
                    if (entry.participatingAs === "jv") {
                        const rows = entry.jvRows || [];
                        const lead = rows.find((r) => r.role === "Lead");
                        const jv = rows.find((r) => r.role === "JV");
                        const associate = rows.find((r) => r.role === "Associate");
                        if (lead?.partner) jvPayload.lead_partner = lead.partner.partner_name;
                        if (jv?.partner) jvPayload.jv_partner = jv.partner.partner_name;
                        if (associate?.partner)
                            jvPayload.associate_partner = associate.partner.partner_name;
                        const extras = rows.filter(
                            (r) => !FIXED_ROLES.includes(r.role) && r.partner
                        );
                        if (extras.length > 0) {
                            jvPayload.extra_partners = extras.map((r) => ({
                                role: r.role,
                                partner: r.partner.partner_name,
                            }));
                        }
                    }
                    return axios.post(`${BASE_URL}/siteproject/bidder/`, {
                        bidder_name: bidderName,
                        TenderforBD: tenderId,
                        participating_as: entry.participatingAs,
                        ...(entry.participatingAs === "jv" && jvPayload),
                    });
                })
            );
            setSelectedPartners([]);
            setParticipatingEntries([]);
            fetchBidders();
        } catch (err) {
            console.error("Error posting bidders:", err);
            setAddError("Failed to add bidders. Please try again.");
        } finally {
            // FIX: this was missing on the success path — button never re-enabled
            setIsAddingBidders(false);
        }
    }

    const canAdd =
        participatingEntries.length > 0 &&
        participatingEntries.every(
            (en) => en.participatingAs && isJvComplete(en)
        );

    function updateRow(id, field, value) {
        setRowState((prev) => ({
            ...prev,
            [id]: { ...prev[id], [field]: value, saved: false, error: "" },
        }));
    }

    function startEditing(id, field) {
        setRowState((prev) => ({
            ...prev,
            [id]: { ...prev[id], [field]: true, saved: false, error: "" },
        }));
    }

    async function saveRow(e, bidderId) {
        e.preventDefault();
        e.stopPropagation();
        const row = rowState[bidderId];
        if (!row) return;
        setRowState((prev) => ({
            ...prev,
            [bidderId]: { ...prev[bidderId], saving: true, error: "" },
        }));
        try {
            const payload = {};
            if (isTechOpen) {
                payload.tech_score =
                    row.tech_score === "Non Responsive"
                        ? "Non Responsive"
                        : row.tech_score;
            }
            if (isFinancialOpen) {
                payload.amount_bid = row.amount_bid;
            }
            await axios.put(`${BASE_URL}/siteproject/bidder/${bidderId}/`, payload);
            setRowState((prev) => ({
                ...prev,
                [bidderId]: {
                    ...prev[bidderId],
                    saving: false,
                    saved: true,
                    techEditing: false,
                    amountEditing: false,
                },
            }));
            fetchBidders();
        } catch {
            setRowState((prev) => ({
                ...prev,
                [bidderId]: { ...prev[bidderId], saving: false, error: "Save failed" },
            }));
        }
    }

    async function handleSubmitWinner(e) {
        e.preventDefault();
        e.stopPropagation();
        if (!selectedWinnerId) return;
        setWinnerSubmitting(true);
        setWinnerSubmitError("");
        try {
            await Promise.all(
                bidders.map((b) =>
                    axios.put(`${BASE_URL}/siteproject/bidder/${b.id}/`, {
                        winning_bidder: b.id === selectedWinnerId,
                    })
                )
            );
            fetchBidders();
        } catch {
            setWinnerSubmitError("Failed to save winner. Please try again.");
        } finally {
            setWinnerSubmitting(false);
        }
    }


    function handleAreWeL1Change(val) {
        const nextVal = val === "true" ? true : val === "false" ? false : null;
        setWishListData((prev) => ({
            ...prev,
            are_we_l1: nextVal,
        }));
        syncBgDetails({ are_we_l1: nextVal });
        syncBidTenderUpdate({ are_we_l1: nextVal });
    }

    function handleTechOpenChange(val) {
        const nextVal = val === "true" ? true : val === "false" ? false : null;
        setWishListData((prev) => ({
            ...prev,
            tech_open: nextVal,
        }));
        syncBgDetails({ tech_open: nextVal });
        syncBidTenderUpdate({ tech_open: nextVal });
    }

    function handleFinancialOpenChange(val) {
        const nextVal = val === "true" ? true : val === "false" ? false : null;
        setWishListData((prev) => ({
            ...prev,
            financial_status: nextVal,
        }));
        syncBidTenderUpdate({ financial_status: nextVal });
    }

    function handleTechResponsiveChange(val) {
        const nextVal = val === "true" ? true : val === "false" ? false : null;
        setWishListData((prev) => ({
            ...prev,
            tech_responsive: nextVal,
        }));
        syncBidTenderUpdate({ tech_responsive: nextVal });
    }



    async function syncBgDetails(overrides = {}) {
        if (!tenderId) {
            console.warn("syncBgDetails: no tenderId — skipping bg sync");
            return;
        }

        if (!tenderIdCode) {
            console.warn("syncBgDetails: tenderIdCode not passed from parent — skipping bg sync");
            return;
        }

        const matchedBg = bgData?.find(
            (bg) => String(bg.tender_id) === String(tenderIdCode)
        );

        if (!matchedBg) {
            console.warn(
                "syncBgDetails: no bgData record matches tender_id",
                tenderIdCode,
                bgData
            );
            return;
        }

        const nextTechOpen =
            overrides.tech_open !== undefined ? overrides.tech_open : wishListData?.tech_open;
        const nextAreWeL1 =
            overrides.are_we_l1 !== undefined ? overrides.are_we_l1 : wishListData?.are_we_l1;

        try {
            await axios.put(
                `${BASE_URL}/siteproject/bgdetailsforbdput/${matchedBg.id}/`,
                {
                    tech_open: nextTechOpen,
                    are_we_l1: nextAreWeL1,
                    is_matured: matchedBg.is_submitted ? true : "",
                    result_open: new Date().toISOString().split("T")[0],
                },
                { headers: { "Content-Type": "application/json" } }
            );
        } catch (err) {
            console.error("Error syncing BG details:", err);
        }
    }

    async function syncBidTenderUpdate(overrides = {}) {
        if (!tenderId) return;

        const payload = {
            tech_open:
                overrides.tech_open !== undefined ? overrides.tech_open : wishListData?.tech_open,
            are_we_l1:
                overrides.are_we_l1 !== undefined ? overrides.are_we_l1 : wishListData?.are_we_l1,
            financial_status:
                overrides.financial_status !== undefined
                    ? overrides.financial_status
                    : wishListData?.financial_status,
            tech_responsive:
                overrides.tech_responsive !== undefined
                    ? overrides.tech_responsive
                    : wishListData?.tech_responsive,
        };

        try {
            await axios.put(
                `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
                payload,
                { headers: { "Content-Type": "application/json" } }
            );
        } catch (err) {
            console.error("Error updating BidTenderUpdate:", err);
        }
    }






    function handleWinnerAnnouncedChange(val) {
        const announced = val === "true";
        setIsWinnerAnnounced(announced);
        setWishListData((prev) => ({ ...prev, is_winner_announced: announced }));
        if (!announced) {
            setSelectedWinnerId(null);
            setWinnerSubmitError("");
        }
    }

    const totalCols =
        2 +
        (showTechColumn ? 1 : 0) +
        (showTechRankColumn ? 1 : 0) +
        (showFinancialColumn ? 1 : 0) +
        (showFinancialRankColumn ? 1 : 0) +
        ((isTechOpen || isFinancialOpen) && !isCvRole ? 1 : 0) +
        (isWinnerAnnounced && !isCvRole ? 1 : 0) +
        (!isCvRole ? 1 : 0); // for the Edit Bidder column

    return (
        <>
            <style>{styles}</style>
            <div className="trs-wrapper">

                {/* ── Edit Bidder Modal ── */}
                {editingBidder && (
                    <EditBidderModal
                        bidder={editingBidder}
                        partners={partners}
                        partnersLoading={partnersLoading}
                        onPartnerCreated={handlePartnerCreated}
                        allBidders={bidders}
                        onSave={() => {
                            setEditingBidder(null);
                            fetchBidders();
                        }}
                        onClose={() => setEditingBidder(null)}
                    />
                )}

                {/* ── Step 1: Bidder multi-select ── */}
                {!isCvRole && (
                    <div className="trs-field-block">
                        <label className="trs-select-label">
                            Select Bidders <span className="trs-required">*</span>
                        </label>
                        <MultiSelectDropdown
                            partners={partners}
                            selected={selectedPartners}
                            onChange={setSelectedPartners}
                            loading={partnersLoading}
                            disabledIds={allJvSubPartnerIds}
                            onPartnerCreated={handlePartnerCreated}
                        />
                    </div>
                )}

                {/* ── Step 2: Participating As cards ── */}
                {!isCvRole && participatingEntries.length > 0 && (
                    <ParticipatingAsBuilder
                        partners={partners}
                        partnersLoading={partnersLoading}
                        entries={participatingEntries}
                        onChange={setParticipatingEntries}
                        onRemove={handleRemoveEntry}
                        onPartnerCreated={handlePartnerCreated}
                    />
                )}

                {/* ── Add Bidders button ── */}
                {!isCvRole && (
                    <div className="trs-field-block">
                        <button
                            type="button"
                            className="trs-add-btn"
                            onClick={handleAddBidders}
                            disabled={!canAdd || isAddingBidders}
                        >
                            {isAddingBidders ? "Added ✓" : "+ Add Bidders"}
                        </button>
                        {addError && (
                            <div className="trs-error" style={{ marginTop: 6 }}>
                                {addError}
                            </div>
                        )}
                    </div>
                )}

                {/* ── Tech Open / Financial Open ── */}
                <div style={{ display: "flex", justifyContent: "space-between", width: "99%" }}>
                    <div className="trs-field-block" style={{ width: "48%" }}>
                        <label className="trs-select-label">
                            Tech Open <span className="trs-required">*</span>
                        </label>
                        <select
                            className="trs-yn-select"
                            value={
                                wishListData?.tech_open === true
                                    ? "true"
                                    : wishListData?.tech_open === false
                                        ? "false"
                                        : ""
                            }
                            onChange={(e) => handleTechOpenChange(e.target.value)}
                        >
                            <option value="">Tech Open</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                    <div className="trs-field-block" style={{ width: "48%" }}>
                        <label className="trs-select-label">
                            Financial Open <span className="trs-required">*</span>
                        </label>
                        <select
                            className="trs-yn-select"
                            value={
                                wishListData?.financial_status === true
                                    ? "true"
                                    : wishListData?.financial_status === false
                                        ? "false"
                                        : ""
                            }
                            onChange={(e) => handleFinancialOpenChange(e.target.value)}
                        >
                            <option value="">Financial Open</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                </div>

                <div className="trs-field-block">
                    <label className="trs-select-label">
                        Is Winner Announced <span className="trs-required">*</span>
                    </label>
                    <select
                        className="trs-yn-select"
                        value={isWinnerAnnounced ? "true" : "false"}
                        onChange={(e) => handleWinnerAnnouncedChange(e.target.value)}
                    >
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                    </select>
                </div>

                {/* ── Bidder Table ── */}
                <div className="trs-field-block">
                    <p className="trs-section-title">Bidders</p>
                    {biddersLoading ? (
                        <div className="trs-loading">Loading bidders…</div>
                    ) : (
                        <div className="trs-table-wrap">
                            <table className="trs-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Bidder Name</th>
                                        {showTechColumn && <th>Tech Score</th>}
                                        {showTechRankColumn && <th>Tech Rank</th>}
                                        {showFinancialColumn && <th>Financial Amount</th>}
                                        {showFinancialRankColumn && <th>Financial Rank</th>}
                                        {(isTechOpen || isFinancialOpen) && !isCvRole && (
                                            <th>Action</th>
                                        )}
                                        {isWinnerAnnounced && !isCvRole && <th>Winner</th>}
                                        {/* NEW: Edit Bidder column */}
                                        {!isCvRole && <th>Edit</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {bidders.length === 0 && (
                                        <tr>
                                            <td
                                                colSpan={totalCols}
                                                style={{ color: "#999", padding: "18px" }}
                                            >
                                                No bidders added yet.
                                            </td>
                                        </tr>
                                    )}
                                    {bidders.map((bidder, idx) => {
                                        const row = rowState[bidder.id] || {};
                                        const hasTechValue =
                                            bidder.tech_score !== null &&
                                            bidder.tech_score !== undefined &&
                                            bidder.tech_score !== "";
                                        const hasAmountValue =
                                            bidder.amount_bid !== null &&
                                            bidder.amount_bid !== undefined &&
                                            bidder.amount_bid !== "";
                                        const techEditing = row.techEditing ?? !hasTechValue;
                                        const amountEditing = row.amountEditing ?? !hasAmountValue;
                                        const isNR = techEditing
                                            ? row.tech_score === "Non Responsive"
                                            : bidder.tech_score === "Non Responsive";
                                        const isWinner = bidder.id === savedWinnerId;
                                        const isSelectedWinner = bidder.id === selectedWinnerId;
                                        const techRank = techRankMap[bidder.id];
                                        const finRank = financialRankMap[bidder.id];
                                        const isBeingEdited = editingBidder?.id === bidder.id;

                                        return (
                                            <tr
                                                key={bidder.id}
                                                className={
                                                    isBeingEdited
                                                        ? "editing-row"
                                                        : isWinner
                                                            ? "winner-row"
                                                            : ""
                                                }
                                            >
                                                <td>{idx + 1}</td>
                                                <td style={{ textAlign: "left", paddingLeft: 14 }}>
                                                    <BidderNameCell bidder={bidder} />
                                                    {bidder.are_we_l1 && (
                                                        <span
                                                            className="trs-badge-l1"
                                                            style={{ marginLeft: 6 }}
                                                        >
                                                            L1
                                                        </span>
                                                    )}
                                                    {isWinner && (
                                                        <span
                                                            className="trs-winner-badge"
                                                            style={{ marginLeft: 6 }}
                                                        >
                                                            🏆 Winner
                                                        </span>
                                                    )}
                                                </td>

                                                {showTechColumn && (
                                                    <td>
                                                        {!isCvRole ? (
                                                            techEditing ? (
                                                                <div
                                                                    className="trs-row-flex"
                                                                    style={{ justifyContent: "center" }}
                                                                >
                                                                    <select
                                                                        className="trs-nr-select"
                                                                        value={
                                                                            isNR ? "Non Responsive" : ""
                                                                        }
                                                                        onChange={(e) =>
                                                                            updateRow(
                                                                                bidder.id,
                                                                                "tech_score",
                                                                                e.target.value === "Non Responsive"
                                                                                    ? "Non Responsive"
                                                                                    : ""
                                                                            )
                                                                        }
                                                                    >
                                                                        <option value="">Responsive</option>
                                                                        <option value="Non Responsive">
                                                                            Non Responsive
                                                                        </option>
                                                                    </select>
                                                                    {!isNR && (
                                                                        <input
                                                                            type="number"
                                                                            className="trs-score-input"
                                                                            placeholder="Score"
                                                                            value={row.tech_score || ""}
                                                                            onChange={(e) =>
                                                                                updateRow(
                                                                                    bidder.id,
                                                                                    "tech_score",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            onWheel={(e) => e.target.blur()}
                                                                        />
                                                                    )}
                                                                    {isNR && (
                                                                        <span className="trs-badge-nr">
                                                                            Non Responsive
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <span className="trs-value-display">
                                                                    {row.tech_score === "Non Responsive" ? (
                                                                        <span className="trs-badge-nr">
                                                                            Non Responsive
                                                                        </span>
                                                                    ) : (
                                                                        <strong>{row.tech_score}</strong>
                                                                    )}
                                                                    <button
                                                                        type="button"
                                                                        className="trs-edit-btn"
                                                                        onClick={() =>
                                                                            startEditing(bidder.id, "techEditing")
                                                                        }
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </span>
                                                            )
                                                        ) : (
                                                            <span>
                                                                {bidder.tech_score === "Non Responsive" ? (
                                                                    <span className="trs-badge-nr">
                                                                        Non Responsive
                                                                    </span>
                                                                ) : (
                                                                    bidder.tech_score ?? "—"
                                                                )}
                                                            </span>
                                                        )}
                                                    </td>
                                                )}

                                                {showTechRankColumn && (
                                                    <td>
                                                        {techRank ? (
                                                            <span
                                                                className={`trs-badge-rank-h${techRank === "H1" ? " h1" : ""
                                                                    }`}
                                                            >
                                                                {techRank}
                                                            </span>
                                                        ) : (
                                                            <span style={{ color: "#ccc", fontSize: 12 }}>
                                                                —
                                                            </span>
                                                        )}
                                                    </td>
                                                )}

                                                {showFinancialColumn && (
                                                    <td>
                                                        {!isCvRole ? (
                                                            isNR ? (
                                                                <span
                                                                    style={{
                                                                        color: "#aaa",
                                                                        fontSize: 12,
                                                                        fontStyle: "italic",
                                                                    }}
                                                                >
                                                                    N/A (Non Responsive)
                                                                </span>
                                                            ) : amountEditing ? (
                                                                <input
                                                                    type="number"
                                                                    className="trs-amount-input"
                                                                    placeholder="Amount"
                                                                    value={row.amount_bid || ""}
                                                                    onChange={(e) =>
                                                                        updateRow(
                                                                            bidder.id,
                                                                            "amount_bid",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    onWheel={(e) => e.target.blur()}
                                                                />
                                                            ) : (
                                                                <span className="trs-value-display">
                                                                    <strong>{row.amount_bid}</strong>
                                                                    <button
                                                                        type="button"
                                                                        className="trs-edit-btn"
                                                                        onClick={() =>
                                                                            startEditing(bidder.id, "amountEditing")
                                                                        }
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </span>
                                                            )
                                                        ) : (
                                                            <span>{bidder.amount_bid ?? "—"}</span>
                                                        )}
                                                    </td>
                                                )}

                                                {showFinancialRankColumn && (
                                                    <td>
                                                        {finRank ? (
                                                            <span
                                                                className={`trs-badge-rank-l${finRank === "L1" ? " l1" : ""
                                                                    }`}
                                                            >
                                                                {finRank}
                                                            </span>
                                                        ) : (
                                                            <span style={{ color: "#ccc", fontSize: 12 }}>
                                                                —
                                                            </span>
                                                        )}
                                                    </td>
                                                )}

                                                {showColumns && !isCvRole && (
                                                    <td>
                                                        {(techEditing || amountEditing) && (
                                                            <>
                                                                <button
                                                                    type="button"
                                                                    className={`trs-save-btn${row.saved ? " saved" : ""
                                                                        }`}
                                                                    onClick={(e) => saveRow(e, bidder.id)}
                                                                    disabled={row.saving}
                                                                >
                                                                    {row.saving
                                                                        ? "…"
                                                                        : row.saved
                                                                            ? "Saved ✓"
                                                                            : "Save"}
                                                                </button>
                                                                {row.error && (
                                                                    <div className="trs-error">{row.error}</div>
                                                                )}
                                                            </>
                                                        )}
                                                        {!techEditing && !amountEditing && row.saved && (
                                                            <span
                                                                style={{
                                                                    color: "#28a745",
                                                                    fontSize: 12,
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                Saved ✓
                                                            </span>
                                                        )}
                                                    </td>
                                                )}

                                                {isWinnerAnnounced && !isCvRole && (
                                                    <td>
                                                        {isNR ? (
                                                            <span style={{ color: "#ccc", fontSize: 11 }}>
                                                                —
                                                            </span>
                                                        ) : (
                                                            <label className="trs-winner-radio">
                                                                <input
                                                                    type="radio"
                                                                    name="winning_bidder"
                                                                    value={bidder.id}
                                                                    checked={isSelectedWinner}
                                                                    onChange={() =>
                                                                        setSelectedWinnerId(bidder.id)
                                                                    }
                                                                />
                                                                <span style={{ fontSize: 12, color: "#555" }}>
                                                                    Select
                                                                </span>
                                                            </label>
                                                        )}
                                                    </td>
                                                )}

                                                {/* NEW: Edit Bidder button column */}
                                                {!isCvRole && (
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="trs-edit-bidder-btn"
                                                            onClick={() => setEditingBidder(bidder)}
                                                            title="Edit bidder name / partners"
                                                        >
                                                            ✏️ Edit
                                                        </button>
                                                    </td>
                                                )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {isWinnerAnnounced && !isCvRole && bidders.length > 0 && (
                        <div>
                            <button
                                type="button"
                                className="trs-winner-submit-btn"
                                onClick={handleSubmitWinner}
                                disabled={!selectedWinnerId || winnerSubmitting}
                            >
                                {winnerSubmitting ? "Saving…" : "🏆 Confirm Winner"}
                            </button>
                            {winnerSubmitError && (
                                <div className="trs-error" style={{ marginTop: 6 }}>
                                    {winnerSubmitError}
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {isTechOpen && (
                    <div className="trs-field-block">
                        <label className="trs-select-label">
                            Tech Responsive <span className="trs-required">*</span>
                        </label>
                        <select
                            className="trs-yn-select"
                            value={
                                wishListData?.tech_responsive === true
                                    ? "true"
                                    : wishListData?.tech_responsive === false
                                        ? "false"
                                        : ""
                            }
                            onChange={(e) => handleTechResponsiveChange(e.target.value)}
                        >
                            <option value="">Tech Responsive</option>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                )}

                <div className="trs-field-block">
                    <label className="trs-select-label">
                        Are We L1 <span className="trs-required">*</span>
                    </label>
                    <select
                        className="trs-yn-select"
                        value={
                            wishListData?.are_we_l1 === true
                                ? "true"
                                : wishListData?.are_we_l1 === false
                                    ? "false"
                                    : ""
                        }
                        onChange={(e) => handleAreWeL1Change(e.target.value)}
                    >
                        <option value="">Are We L1</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>

            </div>
        </>
    );
}